import { useState } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";
import { CSVLink } from "react-csv";


const IncomingData = [
  {
    td1: "INV-1456",
    td2: "11.01.2022",
    td3: `Overdue`,
    td4: "Bedanta Barua",
    td5: "1799",
    td6: "3",
    td7: "Xpress Bees",
    td8: "Archive",
    td9: "VIEW DETAILS",
  },
  {
    td1: "INV-3066",
    td2: "11.01.2022",
    td3: `Unpaid`,
    td4: "Akta Sharma",
    td5: "1819",
    td6: "3",
    td7: "Xpress Bees",
    td8: "Archive",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "11.01.2022",
    td3: `Sent`,
    td4: "Bedanta Barua",
    td5: "1799",
    td6: "1",
    td7: "Xpress Bees",
    td8: "Archive",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "11.01.2022",
    td3: `Paid`,
    td4: "Raj Barua",
    td5: "1219",
    td6: "5",
    td7: "Xpress Bees",
    td8: "Archive",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "11.01.2022",
    td3: `Paid`,
    td4: "Bedanta Barua",
    td5: "1799",
    td6: "3",
    td7: "Xpress Bees",
    td8: "Archive",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3587",
    td2: "11.01.2022",
    td3: `Paid`,
    td4: "Bedanta Barua",
    td5: "1799",
    td6: "3",
    td7: "Xpress Bees",
    td8: "Archive",
    td9: "VIEW DETAILS",
  },{
    td1: "INV-3066",
    td2: "11.01.2022",
    td3: `Unpaid`,
    td4: "Mohit Barua",
    td5: "1799",
    td6: "3",
    td7: "Xpress Bees",
    td8: "Archive",
    td9: "VIEW DETAILS",
  },
];

const DSTable2 = () => {
  const [count, setCount] = useState([]);
  const [type, setType] = useState(0);
  const [filtr, setFiltr] = useState("");
  const [filtr1, setFiltr1] = useState("");

  const handleFilter = (e) => {
    setFiltr(e.target.value);
    setCount(IncomingData.filter((x) => x.td3 === e.target.value));
    setType(0)
  };
  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => x.td6.toString() === e.target.value));
    setType(0)
  };

  const handle1 = () => {
    setType(0);
  };
  const handle2 = () => {
    setType(1);
  };
  const handle3 = () => {
    setType(2);
  };
  const handle4 = () => {
    setType(3);
  };
  const handle5 = () => {
    setType(4);
  };
  useEffect(() => {
    if (type === 1) {
      setCount(
        IncomingData.filter(
          (x) => x.td3 === "Sent"
        )
      );
    } else if (type === 2) {
      setCount(
        IncomingData.filter(
          (x) => x.td3 === "Paid"
        )
      );
    }else if (type === 3) {
      setCount(
        IncomingData.filter(
          (x) => x.td3 === "Overdue"
        )
      );
    } else if (type === 4) {
      setCount(
        IncomingData.filter(
          (x) => x.td3 === "Unpaid"
        )
      );
    } else {
      setCount("");
    }
    setFiltr("");
    setFiltr1("");
  }, [type]);


  return (
    <div id="OMS-main-content">
      <div className="order-list-box" >
        <div className="table_heading">
          <h4>INVOICES</h4>
          <OpenInNewIcon
            style={{ fontSize: "16", marginLeft: "5" }}
          ></OpenInNewIcon>
        </div>
        <div id="click-data">
        <p onClick={handle1} id={type === 0 ? "clicked-type" : ""}>
            All Invoice
          </p>
          <p onClick={handle2} id={type === 1 ? "clicked-type" : ""}>
          Send
          </p>
          <p onClick={handle3} id={type === 2 ? "clicked-type" : ""}>
          Paid
          </p>
          <p onClick={handle4} id={type === 3 ? "clicked-type" : ""}>
          Overdue
          </p>
          <p onClick={handle5} id={type === 4 ? "clicked-type" : ""}>
          Void
          </p>
        </div>
        <div className="order-list-input-box">
          <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by invoice ID, customer name"
              onChange={(val) => {
                setCount(
                  IncomingData.filter((x) =>
                    x.td1.match(val.target.value) || x.td4.match(val.target.value)
                  )
                );
                setFiltr("");
                setFiltr1("");
                setType(0);
              }}
            />
            <div className="searchIcon">
              <SearchIcon
                style={{
                  color: "#fff",
                  width: "20",
                  height: "20",
                  margin: "5 5",
                }}
              ></SearchIcon>
            </div>
          </div>
          <div className="supplier-content-input-right">
            <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
              value={filtr1}
              onChange={handleFilter1}
            >
              <option value="" selected>
                Quantity
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>

            </select>
            <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
              value={filtr}
              onChange={handleFilter}
            >
              <option selected>Order Status</option>
              <option value="Paid">Paid</option>
              <option value="Unpaid">Unpaid</option>
              <option value="Overdue">Overdue</option>
            </select>
            <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
          </div>
        </div>
        <table style={{ textAlign: "center" }}>
          <tr>
            <th>Invoice ID</th>
            <th>Date</th>
            <th>Status</th>
            <th>Customer</th>           
            <th>Invoice Amount</th>
            <th>Quantity</th>
            <th>Courier Partner</th>
            <th>Action</th>
            <th>NA</th>
          </tr>
          {count.length > 0
            ? count.map((val) => {
                return (
                  <tr style={{lineHeight:"2rem"}}>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td className="col-status"
                      id={
                        val.td3 === "Paid"
                          ? "col-green"
                          : val.td3 === "Unpaid"
                          ? "col-red"
                          : val.td3 === "Overdue"
                          ? "col-yellow"
                          : val.td3 === "Sent"
                          ? "col-blue"
                          : ""
                      }>{val.td3}</td>
                    <td>{val.td4}</td>
                    <td>{val.td5}</td>
                    <td>{val.td6}</td>
                    <td>{val.td7}</td>
                    <td>{val.td8}</td>
                    <td className="view-details">{val.td9}</td>
                  </tr>
                );
              })
            : IncomingData.map((val) => {
                return (
                  <tr style={{ lineHeight: "2rem" }}>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td className="col-status"
                      id={
                        val.td3 === "Paid"
                          ? "col-green"
                          : val.td3 === "Unpaid"
                          ? "col-red"
                          : val.td3 === "Overdue"
                          ? "col-yellow"
                          : val.td3 === "Sent"
                          ? "col-blue"
                          : ""
                      }
                      >{val.td3}</td>
                    <td className="">
                      {val.td4}
                    </td>
                    <td>{val.td5}</td>
                    <td>{val.td6}</td>
                    <td>{val.td7}</td>
                    <td>{val.td8}</td>
                    <td className="view-details">{val.td9}</td>
                  </tr>
                );
              })}
        </table>
      </div>
    </div>
  );
};

export default DSTable2;
